import {
    FETCH_BALANCE,
    FETCH_BALANCE_FAILED,
    FETCH_BALANCE_SUCCEEDED,
} from "../../constants/ActionTypes";

const initialState = {
    monetary: null,
    credit: null,
    sms: [],
    // Until the first answer arrives there is nothing to show (null is not "0").
    loading: false,
    loaded: false,
};

const balance = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_BALANCE:
            return {...state, loading: true};
        case FETCH_BALANCE_FAILED:
            return {...state, loading: false};
        case FETCH_BALANCE_SUCCEEDED:
            return {
                ...state,
                loading: false,
                loaded: true,
                sms: action.balance.sms,
                monetary: action.balance.monetary,
                credit: action.balance.credit,
            };
        default:
            return state;
    }
};

export default balance;
